export default __webpack_public_path__ + "static/media/Insert-Lid.be27849b.svg";